(() => {
  const initSlider = (root, { autoplay = 6500 } = {}) => {
    const track = root.querySelector('[data-swiff-track]');
    const slides = [...root.querySelectorAll('[data-swiff-slide]')];
    const dots = [...root.querySelectorAll('[data-swiff-dot]')];
    const prev = root.querySelector('[data-swiff-prev]');
    const next = root.querySelector('[data-swiff-next]');
    if (!slides.length) return;

    let index = 0;
    let timer;

    const go = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (track && track.dataset.mode === 'carousel') {
        track.style.transform = `translateX(-${index * 100}%)`;
      }
    };

    const start = () => {
      if (!autoplay || slides.length < 2) return;
      stop();
      timer = window.setInterval(() => go(index + 1), autoplay);
    };

    const stop = () => window.clearInterval(timer);

    prev?.addEventListener('click', () => {
      go(index - 1);
      start();
    });
    next?.addEventListener('click', () => {
      go(index + 1);
      start();
    });
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        go(i);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    let startX = 0;
    root.addEventListener('touchstart', (event) => {
      startX = event.changedTouches[0].clientX;
      stop();
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      const delta = event.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 40) go(delta < 0 ? index + 1 : index - 1);
      start();
    });

    go(0);
    start();
  };

  document.querySelectorAll('[data-swiff-slider]').forEach((root) => {
    initSlider(root, { autoplay: Number(root.dataset.autoplay || 6500) });
  });
})();
